import { Permission } from './permission';
import { NmvsActionType } from './nmvs-action-type';
import { translations } from './translations';

class NmvsMenuItemObject {
  public text: string;
  public nmvsOperation: NmvsActionType;
  public requiredPermission: Permission;

  constructor(_text: string, _value: NmvsActionType, _permission: Permission) {
    this.text = _text;
    this.nmvsOperation = _value;
    this.requiredPermission = _permission;
  }
}

export type NmvsMenuItem = NmvsMenuItemObject;

export const nmvsMenuOperations = {
  verify: new NmvsMenuItemObject(translations.VerifyStatus, NmvsActionType.Verify, Permission.VerifyStatus),
  dispense: new NmvsMenuItemObject(translations.MarkAsDispensed, NmvsActionType.Dispense, Permission.MarkAsDispense),
  // sample: new NmvsMenuItemObject(translations.MarkAsSampled, NmvsActionType.Sample, Permission.MarkAsSample),
  destroy: new NmvsMenuItemObject(translations.MarkAsDestroyed, NmvsActionType.Destroy, Permission.MarkAsDestroyed) // ,
  // undoDispense: new NmvsMenuItemObject(translations.UndoDispense, NmvsActionType.UndoDispense, Permission.UndoDispense),
  // undoSample: new NmvsMenuItemObject(translations.UndoSample, NmvsActionType.UndoSample, Permission.UndoSample)
};

export const menuOperations: NmvsMenuItemObject[] = [
  nmvsMenuOperations.verify,
  // nmvsMenuOperations.dispense,
  // nmvsMenuOperations.sample,
  // nmvsMenuOperations.destroy,
  // nmvsMenuOperations.undoDispense,
  // nmvsMenuOperations.undoSample
];



// WEBPACK FOOTER //
// ./src/types/nmvs-menu-item.ts